import _ from 'lodash';

import { mapGetters } from 'vuex';

/**
 * Base test data
 *
 * @type  {Object}
 */
const baseTestData = {
    disabled: false,
    placeholder: 'test placeholder',
    id: 'testId',
    name: 'testName',
    value: null,
    defaultValue: null,
    required: false,
    label: 'Test Label',
    mutation: 'testing/DEFAULT_TEST_MUTATION',
    tooltip: 'Testing the Tooltip.',
    vueComponent: 'Date',
};
export default {
    data() {
        return {
            /**
             * An object sent to child components; used to signal that the fields need to be reset, with the ability
             * to limit the reset to only certain fields
             *
             * @type  {Object}
             */
            formFieldsReset: {
                /**
                 * A list of field names to include in a reset action
                 *
                 * @type  {Array}
                 */
                includeFields: [],

                /**
                 * A parameter that is listened by the child components. Changed via moment().valueOf() method to always
                 * set the fresh value.
                 *
                 * @type  {integer}
                 */
                resetData: null,
            },

            /**
             * Tests
             *
             * @type  {Object}
             */
            tests: {
                testDateDefaultSettings: {
                    ...baseTestData,
                },

                testDateTimeDefaultSettings: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                },

                testDateClearButton: {
                    ...baseTestData,
                    value: '2019-02-01',
                },

                testDateTimeClearButton: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                    value: '2019-06-13T14:05',
                },

                testDateDisabled: {
                    ...baseTestData,
                    disabled: true,
                },

                testDateTimeDisabled: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                    disabled: true,
                },

                testDateValue: {
                    ...baseTestData,
                    value: '2019-02-01',
                },

                testDateDefaultValue: {
                    ...baseTestData,
                    defaultValue: '2019-02-01',
                },

                testDateTimeValue: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                    value: '2019-06-13T14:05',
                },

                testDateTimeDefaultValue: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                    defaultValue: '2019-06-13T14:05',
                },

                testDateInvalidValue: {
                    ...baseTestData,
                    value: 'test invalid date format',
                },

                testDateTimeInvalidValue: {
                    ...baseTestData,
                    vueComponent: 'DateTime',
                    value: 'test invalid date format',
                },
                testDateRequired: {
                    ...baseTestData,
                    required: true,
                },
                testDateTimeRequired: {
                    ...baseTestData,
                    required: true,
                },
            },

            /**
             * Selected test data
             *
             * @type  {Object}
             */
            test: {},
        };
    },

    /**
     * Set the computed property
     *
     * @type  {Object}
     */
    computed: {
        ...mapGetters({
            testingState: 'testing/testing',
        }),

        /**
         * Toggles the tested component
         *
         * @return  {boolean}
         */
        showComponent() {
            return !_.isEmpty(this.test);
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.test = this.tests[this.$route.params.test];
    },
};
